module.exports = __webpack_public_path__ + "04b57d5bd5783a122709f505c9da7629.svg";